module.exports = __webpack_public_path__ + "static/media/sample_candidates.4c296e0e.csv";